import React, { useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import {
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  arrayUnion,
  serverTimestamp,
  arrayRemove,
} from "firebase/firestore";

const AuthContext = React.createContext();
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  // --- PURE AUTH WRAPPERS ---
  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }
  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function logOut() {
    return auth.signOut();
  }
  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }
  async function signInWithGoogle() {
    // On délègue juste la popup, on ne touche PAS au Firestore ici
    return signInWithPopup(auth, new GoogleAuthProvider());
  }

  async function ensureProfile(user) {
    const profileRef = doc(db, "profilsUsers", user.uid);
    const profileSnap = await getDoc(profileRef);

    if (!profileSnap.exists()) {
      await setDoc(profileRef, {
        language: "en",
        name: user.displayName,
        email: user.email,
        photoUrl: user.photoURL,
        createdAt: serverTimestamp(),
      });
    }
  }

  // --- ON AUTH STATE CHANGE ---
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        await ensureProfile(user);
      }
      setCurrentUser(user);
      setLoading(false);
    });
    return unsub;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logOut,
    resetPassword,
    signInWithGoogle,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
